module.exports = __webpack_public_path__ + "static/media/logo105.66d1227d.png";